import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

const QRScanner = ({ onScanSuccess }) => {
  const scannerRef = useRef(null);
  const isStoppingRef = useRef(false);

  useEffect(() => {
    const scanner = new Html5Qrcode("qr-reader");
    scannerRef.current = scanner;

    scanner
      .start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: 250,
        },
        async (decodedText) => {
          if (isStoppingRef.current) return;

          isStoppingRef.current = true;

          try {
            await scanner.stop();   
            await scanner.clear();  
          } catch (err) {
            console.log("Stop error:", err);
          }

          onScanSuccess(decodedText);
        },
        () => {}
      )
      .catch((err) => {
        console.error("QR Scanner Error:", err);
      });

    return () => {
      if (scannerRef.current && !isStoppingRef.current) {
        isStoppingRef.current = true;
        scannerRef.current.stop().catch(() => {});
      }
    };
  }, [onScanSuccess]);

  return <div id="qr-reader" style={{ width: "300px" }} />;
};

export default QRScanner;